import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound, ArrowLeft, Mail } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatLoginError } from "../lib/api";
import { Logo } from "../components/Logo";
import { Button, Field, inputCls } from "../components/ui-kit";
import OfflineAccessButton from "../components/OfflineAccessButton";

// device id persistente: serve a riconoscere i dispositivi nuovi (notifica al consulente)
function getDeviceId() {
  let d = localStorage.getItem("device_id");
  if (!d) { d = "dev-" + Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("device_id", d); }
  return d;
}
function getSavedAccess() {
  try { return JSON.parse(localStorage.getItem("pin_access_profile") || "{}"); } catch { return {}; }
}

export default function PinLogin() {
  const { pinLogin } = useAuth();
  const nav = useNavigate();
  const savedAccess = getSavedAccess();
  const [email, setEmail] = useState(savedAccess.email || "");
  const [rememberAccess, setRememberAccess] = useState(true);
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await pinLogin({ email, pin, device_id: getDeviceId() });
      if (rememberAccess) localStorage.setItem("pin_access_profile", JSON.stringify({ email }));
      else localStorage.removeItem("pin_access_profile");
      toast.success("Accesso addetto effettuato");
      nav("/app", { replace: true });
    } catch (e2) {
      const m = formatLoginError(e2);
      setErr(m); toast.error(m);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-navy p-6">
      <div className="w-full max-w-md animate-fade-up">
        <div className="flex justify-center mb-6"><Logo size="md" variant="dark" /></div>
        <div className="bg-white rounded-2xl shadow-card p-7">
          <div className="flex items-center gap-2 justify-center mb-1 text-gold">
            <KeyRound className="w-5 h-5" />
            <span className="text-xs uppercase tracking-[0.2em] font-body">Accesso rapido addetto</span>
          </div>
          <h2 className="text-center font-heading text-2xl font-bold mb-1">Accedi con il PIN</h2>
          <p className="text-center text-slate-500 text-sm mb-6 font-body">
            Inserisci l’email aziendale (è la stessa per tutto il personale) e il tuo PIN personale. Il dispositivo può ricordare l’email: in seguito ti basterà il PIN.
          </p>
          <form onSubmit={submit} className="space-y-4" data-testid="pin-form">
            <Field label="Email aziendale">
              <div className="relative">
                <Mail className="w-4 h-4 text-slate-400 absolute left-3.5 top-1/2 -translate-y-1/2 z-10" />
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  autoComplete="username" autoCapitalize="none" autoCorrect="off" spellCheck={false}
                  className={`${inputCls} pl-10`} placeholder="info@azienda.it" data-testid="pin-email" />
              </div>
            </Field>
            <Field label="PIN personale">
              <input type="password" inputMode="numeric" required value={pin} onChange={(e) => setPin(e.target.value)}
                className={`${inputCls} tracking-[0.4em] text-center text-lg`} placeholder="••••" data-testid="pin-code" />
            </Field>
            <label className="flex cursor-pointer items-start gap-3 rounded-lg border border-hairline bg-slate-50 p-3 text-sm text-slate-600"><input type="checkbox" checked={rememberAccess} onChange={(e) => setRememberAccess(e.target.checked)} className="mt-0.5 h-5 w-5 accent-emerald-600" /><span><span className="block font-medium text-navy">Ricorda questo accesso</span><span className="block text-xs text-slate-400">L’email aziendale resterà precompilata su questo dispositivo.</span></span></label>
            {err && <p className="text-sm text-haccp-error" data-testid="pin-error">{err}</p>}
            <Button type="submit" variant="accent" loading={loading} className="w-full" data-testid="pin-submit">
              Entra
            </Button>
          </form>
          <Link to="/login" className="mt-5 flex items-center justify-center gap-1.5 text-sm text-slate-500 hover:text-navy" data-testid="link-back-login">
            <ArrowLeft className="w-4 h-4" /> Torna all'accesso con password
          </Link>
          <OfflineAccessButton />
        </div>
      </div>
    </div>
  );
}
